import React, { useEffect, useState } from 'react';
import { Row } from 'reactstrap';
import isEmpty from 'lodash/isEmpty';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import { fetchTopSellers } from 'Redux/ducks/algolia-calls';
import HitCard from 'Components/Cards/HitCard';
import PriceContainer from 'Components/Utility/Price/PriceContainer';
import BrowseButton from 'Components/Utility/BrowseButton';

export default function TopSellersRow({ topSellersType }) {
  const [hits, setHits] = useState([]);

  useEffect(() => {
    const fetchHits = async () => {
      const topSellers = await fetchTopSellers(topSellersType, 4);
      setHits(topSellers.hits);
    };

    fetchHits();
  }, [topSellersType]);

  if (isEmpty(hits)) return false;

  return (
    <div className="container">
      <div className="d-flex mt-5 pb-3">
        <h4><FormattedMessage id="topsellers.header" defaultMessage="Top Sellers" /></h4>
        <BrowseButton className={'view-all-btn'} location={'top-sellers'} />
      </div>
      <Row>
        {hits.map(hit =>
          <HitCard
            key={hit.objectID}
            hit={hit}
            xsSize={12}
            mdSize={6}
            lgSize={3}
          >
            <PriceContainer
              discountPercent={hit.discount_percent}
              price={hit.price}
              tiered={hit.tiered}
              slug={hit.slug}
              hideDiscount={hit.hide_discount}
              payWhatYouWant={hit.pay_what_you_want}
            />
          </HitCard>,
        )}
      </Row>
    </div>
  );
}


TopSellersRow.propTypes = {
  topSellersType: PropTypes.string,
};

TopSellersRow.defaultProps = {
  topSellersType: '',
};
